export default defineNuxtPlugin((nuxtApp) => {
    const { $loader } = nuxtApp;
    const ROUTE_ID = 'route';

    nuxtApp.hook('page:start', () => $loader.start(ROUTE_ID));
    nuxtApp.hook('page:finish', () => $loader.finish(ROUTE_ID));
})
